import * as Ariakit from "@ariakit/react";
import {
	type PropsWithChildren,
	useCallback,
	useEffect,
	useState,
} from "react";

type Props = {
	content: React.ReactNode;
	className?: string;
};

export default function Tooltip({
	children,
	content,
}: PropsWithChildren<Props>) {
	const [open, setOpen] = useState(false);
	const close = useCallback(() => setOpen(false), []);
	useEffect(() => {
		window.addEventListener("scroll", close);
		return () => window.removeEventListener("scroll", close);
	});
	return (
		<Ariakit.TooltipProvider placement="top" open={open} setOpen={setOpen}>
			<Ariakit.TooltipAnchor onClick={() => setOpen(!open)}>
				{children}
			</Ariakit.TooltipAnchor>
			<Ariakit.Tooltip style={{ zIndex: 9999 }} portal={false}>
				{content}
			</Ariakit.Tooltip>
		</Ariakit.TooltipProvider>
	);
}
